// extracted by mini-css-extract-plugin
export default {"card":"CardTestimony_card__t6Kht"};